/* --slider-- */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.swiper').forEach((swiperElement) => {
    const counterElement = document.createElement('div');
    counterElement.classList.add('swiper-counter');
    swiperElement.parentNode.appendChild(counterElement); 
    
    const swiperInstance = new Swiper(swiperElement, {
      loop: true, 
      autoplay: {
        delay: 3000,
      },
      speed: 800,
      on: {
        init: function () {
          const totalSlides = this.slides.filter((slide) => !slide.classList.contains('swiper-slide-duplicate')).length; 
          const currentIndex = this.realIndex + 1; 
          counterElement.textContent = `${currentIndex}/${totalSlides}`;
        },
        slideChange: function () {
          const totalSlides = this.slides.filter((slide) => !slide.classList.contains('swiper-slide-duplicate')).length; 
          const currentIndex = this.realIndex + 1; 
          counterElement.textContent = `${currentIndex}/${totalSlides}`;
        },
      },
    });
  });
});
